requirejs.config({
	'waitSeconds': 60,
    'baseUrl': '/js/',
    'urlArgs': "bust=" + (new Date()).getTime(),
    'paths': {
      'jquery': 'vendor/libs/jquery-3.6.0.min',
      'jquery-ui': 'vendor/libs/jquery-ui.min',
      'data-table': '//cdn.datatables.net/1.11.3/js/jquery.dataTables.min.js', //CDN
      'paging': 'vendor/libs/paging'
    }
});

// Load the main app module to start the app
requirejs(['/js/script.min.js', '//cdn.datatables.net/1.11.3/js/jquery.dataTables.min.js']); //?2021-09-06-1023

// selecting loading div
const loader = document.querySelector("#loading");

// showing loading
function displayLoading() {
    loader.classList.add("display");
}

// hiding loading 
function hideLoading() {
    loader.classList.remove("display");
}